define([
    'underscore',
    'text!./templates/address-std-confirm-template.html',
    'text!./templates/address-success-template.html',
    'text!./templates/address-soft-error-template.html',
    'text!./templates/address-hard-error-template.html',
    'text!./templates/disclaimer-template.html',
    'text!./templates/coverageAlert-template.html',
    'text!./templates/custom-template.html',
    'text!./templates/message-template.html',
    'text!./templates/progress-template.html',
    'text!./templates/esign-agreement-template.html',
], (_,addressStdTemplate, addressSuccessTemplate, addressSoftErrorTemplate, addressHardErrorTemplate, disclaimerTemplate, coverageAlertTemplate, customTemplate, messageTemplate, progressTemplate, eSignAgreementTemplate)=> {//remove membersip template file from dependency as a part of DFCT0020740 and added in PaPolicyInfoCtrl//Arpita 
    const _showMessage = ($filter, $modal, title, message, description, actionObj, iconClass, templateStr, showCancel, options, cancelBtnLabel,customOptions)=> {
        const opts = {
            template: templateStr,
            backdrop: true,
            controller: 'ModalController',
            resolve: {
                model: ()=> {
                    return {
                        title,
                        message,                        
                        description,
                        showCancelBtn: showCancel,
                        keyboard: 'false',
                        iconClass,
                        cancelBtnLabel: cancelBtnLabel || $filter('translate')('platform.modal.ModalService.Close'),
                        action: actionObj,
                        customOptions:customOptions ||{}
                        
                    };
                }
            }
        };
        if (options) {
            angular.extend(opts, options);
        }

        return $modal.open(opts);
    };

    const _showDisclaimerMessage = ($filter, $modal, title, message, description, actionObj, iconClass, templateStr, showCancel, options, cancelBtnLabel,customOptions)=> {
        const opts = {
            template: templateStr,
            backdrop: true,
            controller: 'ModalController',
            resolve: {
                model: ()=> {
                    return {
                        title,
                        message,
                        description,
                        showCancelBtn: showCancel,
                        keyboard: 'false',
                        iconClass,
                        cancelBtnLabel: cancelBtnLabel || $filter('translate')('platform.modal.ModalService.Cancel'),
                        action: actionObj,
                        customOptions:customOptions ||{}

                    };
                }
            }
        };
        if (options) {
            angular.extend(opts, options);
        }

        return $modal.open(opts);
    };


    return ['$modal', '$filter', '$q', ($modal, $filter, $q)=> {
        return {

            showCustomInfo: (title, message, description, actionLabel, actionBtnClass)=> {
                                
                const actionProperties = {
                    label: actionLabel || $filter('translate')('platform.modal.ModalService.Close'),
                    btnClass: actionBtnClass || 'gw-btn-primary',
                    backdrop: 'static'
                };

                return _showMessage($filter, $modal, title, message, description, actionProperties, '', customTemplate);
            },
            showInfo: (title, message, description, actionLabel, actionBtnClass)=> {
                const actionProperties = {
                    label: actionLabel || $filter('translate')('platform.modal.ModalService.Ok'),
                    btnClass: actionBtnClass || 'gw-btn-primary',
                    backdrop: 'static'
                };

                return _showMessage($filter, $modal, title, message, description, actionProperties, 'gw-messageInformationIcon', messageTemplate);
            },

            showDisclaimer: function (title, message, description, actionLabel, actionBtnClass, cancelLabel) {
                var actionProperties = {
                label: actionLabel || $filter('translate')('platform.modal.ModalService.DisclaimerNext'),
                btnClass: actionBtnClass || 'gw-btn-primary',
                backdrop: 'static'
                };
                cancelLabel = cancelLabel || $filter('translate')('platform.modal.ModalService.Cancel');
                return _showDisclaimerMessage($filter, $modal, title, message, description, actionProperties, 'messageInformationIcon', disclaimerTemplate, cancelLabel);
            },

/*
        CHG0031272 - Display alert popup message when comprehensive or collision coverages are not selected
        AB - 06/27/2018
*/
            showCoverageAlert: function (title, message, description, actionLabel, actionBtnClass, cancelLabel) {
                var actionProperties = {
                label: actionLabel || $filter('translate')('platform.modal.ModalService.CoverageAlertYes'),
                btnClass: actionBtnClass || 'gw-btn-primary',
                backdrop: 'static'
                };
                cancelLabel = cancelLabel || $filter('translate')('platform.modal.ModalService.CoverageAlertNo');
                 const opts = {
                         keyboard: false
                     };
                      return _showDisclaimerMessage($filter, $modal, title, message, description, actionProperties, 'messageInformationIcon', coverageAlertTemplate, true, opts, cancelLabel);
            },

/*
        CHG0032036 - Omega Integration with Melissa Data Service
        Display popup message when Melissa Data Service returns soft errors
        AB - 01/10/2019
*/
            showMelissaSuccessPopup: function (title, message, description, actionLabel, actionBtnClass, cancelLabel) {
                var actionProperties = {
                label: actionLabel || $filter('translate')('platform.modal.ModalService.MelissaSuccessYes'),
                btnClass: actionBtnClass || 'gw-btn-primary',
                backdrop: 'static'
                };
                cancelLabel = cancelLabel || $filter('translate')('platform.modal.ModalService.MelissaSuccessNo');
                 const opts = {
                         keyboard: false
                     };
                      return _showDisclaimerMessage($filter, $modal, title, message, description, actionProperties, 'messageInformationIcon', addressSuccessTemplate, true, opts, cancelLabel);
            },

            showMelissaWarningPopup: function (title, message, description, actionLabel, actionBtnClass, cancelLabel) {
                var actionProperties = {
                label: actionLabel || $filter('translate')('platform.modal.ModalService.MelissaWarningYes'),
                btnClass: actionBtnClass || 'gw-btn-primary',
                backdrop: 'static'
                };
                cancelLabel = cancelLabel || $filter('translate')('platform.modal.ModalService.MelissaWarningNo');
                 const opts = {
                         keyboard: false
                     };
                      return _showDisclaimerMessage($filter, $modal, title, message, description, actionProperties, 'messageInformationIcon', addressSoftErrorTemplate, true, opts, cancelLabel);
            },

            showMelissaErrorPopup: function (title, message, description, actionLabel, actionBtnClass, cancelLabel) {
                var actionProperties = {
                label: actionLabel || $filter('translate')('platform.modal.ModalService.Ok'),
                btnClass: actionBtnClass || 'gw-btn-primary',
                backdrop: 'static'
                };
                return _showDisclaimerMessage($filter, $modal, title, message, description, actionProperties, 'messageInformationIcon', addressHardErrorTemplate, true, opts, cancelLabel);
            },

            showConfirm: (title, message, description, actionLabel, actionBtnClass, cancelLabel)=> {
                const actionProperties = {
                    label: actionLabel,
                    btnClass: actionBtnClass || 'gw-btn-primary'
                };
                cancelLabel = cancelLabel || $filter('translate')('platform.modal.ModalService.Cancel');
                const opts = {
                    keyboard: false
                };
                return _showMessage($filter, $modal, title, message, description, actionProperties, 'gw-messageQuestionIcon', messageTemplate, true, opts, cancelLabel);
            },

            showWarning: (title, message, description, actionLabel, actionBtnClass, cancelLabel)=> {
                const actionProperties = {
                    label: actionLabel || $filter('translate')('platform.modal.ModalService.Yes'),
                    btnClass: actionBtnClass || 'gw-btn-primary'
                };
                const opts = {
                    keyboard: false
                };
                cancelLabel = cancelLabel || $filter('translate')('platform.modal.ModalService.Cancel');
                return _showMessage($filter, $modal, title, message, description, actionProperties, 'gw-messageWarningIcon', messageTemplate, true, opts, cancelLabel);
            },

            showError: (title, message, description, actionLabel, actionBtnClass)=> {
                
                title = $filter('translate')('platform.modal.ModalService.Attention');
                
                const actionProperties = {
                    label: actionLabel || $filter('translate')('platform.modal.ModalService.Close'),
                    btnClass: actionBtnClass
                };
                return _showMessage($filter, $modal, title, message, description, actionProperties, 'gw-messageErrorIcon', messageTemplate);
            },

            showSuccess: (title, message, description, actionLabel, actionBtnClass)=> {
                const actionProperties = {
                    label: actionLabel || $filter('translate')('platform.modal.ModalService.Ok'),
                    btnClass: actionBtnClass || 'gw-btn-primary'
                };
                return _showMessage($filter, $modal, title, message, description, actionProperties, 'gw-messageSuccessIcon', messageTemplate);
            },
            
            showAddressStandard: function ( message,validationMessage, address,description, actionLabel, actionBtnClass) {
                    var actionProperties = {
                    label: actionLabel || $filter('translate')('platform.modal.ModalService.Yes'),
                            btnClass: actionBtnClass || 'gw-btn-primary',
                            backdrop: 'static'
                    };
                    var title ="t"
                    var customOptions = {validationMessage:validationMessage,address: address}
                    return _showMessage($filter, $modal,  title, message,  description, actionProperties, 'messageInformationIcon', addressStdTemplate, true, {},"C",customOptions);
            },
            
            showAddressStandardNew: function ( message, address,description, actionLabel, actionBtnClass) {
                    var actionProperties = {
                    label: actionLabel || $filter('translate')('platform.modal.ModalService.Yes'),
                            btnClass: actionBtnClass || 'gw-btn-primary',
                            backdrop: 'static'
                    };
                    var title ="t"
                    var customOptions = {address: address}
                    return _showMessage($filter, $modal,  title, message,  description, actionProperties, 'messageInformationIcon', addressStdTemplate, true, {},"C",customOptions);
            },

            showEsignAgreementModal: function () {
                
                var title, message, description = null;
                
                var actionProperties = {
                    label: 'Next',
                    btnClass: 'gw-btn-primary',
                    backdrop: 'static'
                };
                
                return _showMessage($filter, $modal, title, message, description, actionProperties, 'gw-messageWarningIcon', eSignAgreementTemplate);
            },
            
            showProgressMessage: (title) => {
                
                const msgBox = $modal.open({
                    template: progressTemplate,
                    keyboard: false,
                    backdrop: 'static',
                    controller: 'ModalController',
                    resolve: {
                        model: () => {
                            return {
                                title
                            };
                        }
                    }
                });
                
                return msgBox;
            },
            showMembershipDetails: (title) => {//ENHC0011961 - EoDB Membership detail popup -- Arpita
                
                const msgBox = $modal.open({
                    template: membershipDetailTemplate,
                    keyboard: false,
                    backdrop: 'static',
                    controller: 'ModalController',
                    resolve: {
                        model: () => {
                            return {
                                title
                            };
                        }
                    }
                });
                
                return msgBox;
            },//ended
            showLoadingDialog: (title) => {
                const msgBox = $modal.open({
                    template: progressTemplate,
                    keyboard: false,
                    backdrop: 'static',
                    controller: 'ModalController',
                        resolve: {
                            model: () => {
                            return {
                                title
                            };
                        }
                    }
                });
                    
                return msgBox;
            },
                
            showProgressDialog: (title, hidePromise)=> {
                const msgBox = $modal.open({
                    template: progressTemplate,
                    keyboard: false,
                    backdrop: 'static',
                    controller: 'ModalController',
                    resolve: {
                        model: ()=> {
                            return {
                                title
                            };
                        }
                    }
                });

                msgBox.opened.then(() => {
                    $q.when(hidePromise, response => {
                        msgBox.close(response);
                        return response;
                    }, error => {
                        msgBox.dismiss(error);
                        return error;
                    });
                });

                return msgBox;
            },

            showTwoPromiseProgressDialog: (title, hidePromise1, hidePromise2)=> {
                const msgBox = $modal.open({
                    template: progressTemplate,
                    keyboard: false,
                    backdrop: 'static',
                    controller: 'ModalController',
                    resolve: {
                        model: ()=> {
                            return {
                                title
                            };
                        }
                    }
                });

                let prom1Returned = false;
                let prom2Returned = false;

                $q.when(hidePromise1, ()=> {
                    prom1Returned = true;
                    if (prom2Returned === true) {
                        msgBox.close();
                    }
                }, (error)=> {
                    console.error(error);
                    msgBox.close();
                    return $q.reject([error]);
                });

                $q.when(hidePromise2, ()=> {
                    prom2Returned = true;
                    if (prom1Returned === true) {
                        msgBox.close();
                    }
                }, (error)=> {
                    console.error(error);
                    msgBox.close();
                    return $q.reject([error]);
                });
            },

            /**
             * Shows a simple dialog composed of external template and controller components. It allows user to create
             * new dialog using just a simple functions and not a separate "controller" instance (which is anyway
             * just a same collection of functions). Not recommended for a complex scenarios (use separate controller
             * instead).
             *
             * @param template data rendering template.
             * @param data simple scope data. This map is copied to scope "as-is". Useful to provide initial (or data)
             * model values, some basic (non-scope) functions.
             * @param scopeFunctions functions to bind to a scope. This map should have only a functions as it's values.
             * Each that function should receive a $scope argument as it's first value. This functions are bound
             * (partially applied) to a context. Result of that partial application is bound to the scope using
             * original function's key.
             * <p> Example. If we have a pair 'someFunction' : function($scope, a, b, c) {}, resulting scope will have
             * a function 'someFunction': function(a, b, c) {};
             * @param initializer optional function to invoke on the scope. This function may install watches,
             * binding, etc...
             */
            'showSimpleDialog': (template, data, scopeFunctions, initializer)=> {
                $modal.open({
                    template,
                    backdrop: 'static',
                    controller: ['$scope', ($scope)=> {
                        let key;
                        if (data) {
                            for (key in data) {
                                if (data.hasOwnProperty(key)) {
                                    $scope[key] = data[key];
                                }
                            }
                        }

                        if (scopeFunctions) {
                            for (key in scopeFunctions) {
                                if (scopeFunctions.hasOwnProperty(key)) {
                                    $scope[key] = _.partial(scopeFunctions[key], $scope);
                                }
                            }
                        }

                        if (initializer) {
                            initializer($scope);
                        }
                    }]
                });
            }

        };
    }];
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/modal/ModalService.js
 **/